var React = require('react');

function IconLine16IconLineTime16 (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#091E42","strokeLinecap":"round","strokeLinejoin":"round","d":"M1 8c0 1.857.738 3.637 2.05 4.95C4.363 14.263 6.143 15 8 15c1.857 0 3.637-.738 4.95-2.05C14.263 11.637 15 9.857 15 8c0-1.857-.738-3.637-2.05-4.95C11.637 1.738 9.857 1 8 1c-1.857 0-3.637.738-4.95 2.05C1.738 4.363 1 6.143 1 8v0zM8 8V5.5M8 8l3.125 3.125"}));
}

IconLine16IconLineTime16.defaultProps = {"width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"};

module.exports = IconLine16IconLineTime16;

IconLine16IconLineTime16.default = IconLine16IconLineTime16;
